var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HeaderComponent'),_c('ThreeJs'),_c('Hero'),_c('About'),_c('Process'),_c('Skills'),_c('Projects'),_c('Faq'),_c('Contact'),_c('ScrollToUp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }